import { render, staticRenderFns } from "./editOrgDialog.vue?vue&type=template&id=51a71bee&scoped=true"
import script from "./editOrgDialog.vue?vue&type=script&lang=js"
export * from "./editOrgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a71bee",
  null
  
)

export default component.exports